export const FeatureTypes = {
  AiTierOne: 'ai_tier_one',
  AiTierTwo: 'ai_tier_two',
  AiTierThree: 'ai_tier_three',
  AiDocumentAnalysis: 'ai_document_analysis'
};

export const AiFeatureTypes = [
  FeatureTypes.AiTierOne,
  FeatureTypes.AiTierTwo,
  FeatureTypes.AiTierThree
];

